import React, { useState, useEffect } from 'react';
import { Col, Row, Form, Card, Button, Accordion, Tab, Tabs } from 'react-bootstrap';
import { CustomButton } from '../../../shared/customButton';
import styles from './candidateSpecialNotesView.module.scss';
const moment = require('moment');

const CandidateSpecialNotesView = (props) => {

    let [candiateDetails, setCandidateDetails] = useState(props.candidateValues);

    return (
        <div>
            <div className="mt-3">
                <Card className={styles.cvViewCard}>
                    <Card.Header className={styles.cardHeader}>
                        <div className={styles.headerDetails}>
                            <p className={styles.accordianHeaderTopic}> <span className={styles.specialNoteardHeader}> Special Notes for {props.candidateValues && props.candidateValues.candidate_name} </span></p>
                        </div>
                    </Card.Header>
                    <Card.Body className={styles.cvViewBody}>
                        <>
                            {props.candidateValues && props.candidateValues.special_notes.map((values, index) => (
                                <Row className='mb-3'>
                                    <Col className="text-left">
                                        <div>
                                            <div className={styles.headerBox}>
                                                <p className={styles.headerBoxText}>Special Note {index + 1}</p>
                                            </div>
                                            <div className={styles.bodyBox}>
                                                <div className={styles.textDiv}>
                                                    <p className={styles.labelText}>Date and Time :</p>
                                                    <p className={styles.textValue}>{moment(values.added_at).format('DD MMM YYYY - hh:mm A')}</p>
                                                </div>
                                                <div className={styles.textDiv}>
                                                    <p className={styles.labelText}>Added by :</p>
                                                    <p className={styles.textValue}>{values.companyUser_name} ({values.campanyUser_email})</p>
                                                </div>
                                                <div className={styles.textDiv}>
                                                    <p className={styles.labelText}>Note :</p>
                                                    <p className={styles.textValue}>{values.note}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            ))}
                            <CustomButton
                                id="add_special_note"
                                buttonType="button"
                                label="Add Special Note"
                                type="secondaryBtn"
                                handleClick={() => props.openSpecialNoteModal()}
                                frontIcon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                        <path d="M10 4.66667V16.3333M4.16669 10.5H15.8334" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                }

                            />
                        </>
                    </Card.Body>
                </Card>
            </div>
        </div>
    )           
}
    
export default CandidateSpecialNotesView;